export default "__VITE_ASSET__CT8jPApy__"